import React, { useState, useEffect } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsGetAll } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 170 },
  { Header: 'Cod Cliente', accessor: 'CardCode', width: 150 },
  { Header: 'Cliente', accessor: 'CardName', width: 350 },
  { Header: 'Usuario', accessor: 'oauth_name'},
  { Header: 'Vendedor', accessor: 'SlpName', width: 270 },
  { Header: 'total_order', accessor: 'total_order', width: 270 },
  { Header: 'Zona', accessor: 'zone', width: 125 },
  { Header: 'Ruta', accessor: 'route', width: 250 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

function FueraRutaCartera() {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [filter, setFilter] = useState({});

  async function loadCustomers() {
    const params = new URLSearchParams();
    params.append('start_date', filter.start_date);
    params.append('end_date', filter.end_date);
    params.append('route_type', filter.state);
    if (filter.base_zone_id !== undefined) {
      params.append('base_zone_id', filter.base_zone_id);
    }

    setCustomers([]);
    setLoading(true);
    let res = await wsGetAll(
      `base/daily-customer-portfolio-detail/get-data-customers?${params.toString()}`,
    );
    setLoading(false);
    if (res.success) setCustomers(res.data);
  }

  useEffect(() => {
    if (Object.keys(filter).length === 0) return;
    loadCustomers();
  }, [filter]);

  return (
    <CardContainer title="Clientes fuera de ruta/cartera">
      <FilterCustom
        dateRange
        getFilter={setFilter}
        state
        zone
        defaultState="F"
        optionValues={['F', 'C']}
        nameOptions={['Fuera de Ruta', 'Fuera de Cartera']}
        customControl={<>{loading && <LoadingSpinner />}</>}
      />

      <ReactTable
        excelName="clientes-fuera-ruta-cartera"
        defaultWidth={1400}
        columns={columns}
        data={customers.map((customer, index) => {
          return {
            num: index + 1,
            created_at: customer.created_at,
            CardCode: customer.CardCode,
            CardName: customer.CardName,
            oauth_name: customer.oauth_name,
            SlpName: customer.SlpName,
            total_order: parseFloat(customer.total_order).toFixed(2),
            zone: customer.Zona,
            route: customer.RutaOriginal,
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}

export default FueraRutaCartera;
